<template>
    <div class="gameItem" :class="{ biaoTiLan: result.type == 'biaoTiLan' }" @click="RunGameLibrary()">
        <div class="loadingBox" :class="{ loding: typeof result != 'object' }">
            <transition-group
                name="list"
                tag="div"
                :css="false"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
            >
                <div
                    class="animationBox"
                    v-if="
                        typeof result == 'object' && result.type.indexOf('youXi') != -1
                    "
                    :key="dataIndex + 'animation'"
                >
                    <img class="game-cover" :src="result.gameInfo.coverImageUrl" />
                    <div class="gameContent">
                        <div class="gameInfes">
                            <div class="game-detail" ref="detail">
                                <!-- 游戏名称 -->
                                <div class="game-name">
                                    {{ result.gameInfo.title }}
                                </div>
                                <!-- 游戏评分 -->
                                <div class="game-score">
                                    <!-- 已发售 -->
                                    <template v-if="result.gameInfo.isPublished">
                                        <div class="score-star">
                                            <div
                                                :style="{
                                                    width: (result.gameScoreInfo.userScore / 10) * 100 + '%'
                                                }"
                                            ></div>
                                        </div>
                                        <div class="score-text">
                                            {{
                                                result.gameScoreInfo.userScore > 0
                                                    ? result.gameScoreInfo.userScore
                                                    : "无评分"
                                            }}
                                        </div>
                                        <!-- <div class="score-number">
                                    {{
                                        result.gameScoreInfo.scoreUsersCount
                                    }}人评分
                                </div> -->
                                    </template>
                                    <!-- 未发售 -->
                                    <template v-else>
                                        <div class="score-number">{{ result.gameScoreInfo.wantPlaysCount }}人关注</div>
                                    </template>
                                </div>
                                <!-- 游戏Tag -->
                                <div class="game-tag">
                                    {{ result.gameInfo.tagsCaption }}
                                </div>
                                <!-- 游戏平台 -->
                                <div class="game-template">
                                    <template v-if="resetType(result.type, 'PingTai')">
                                        <div
                                            class="template-icon"
                                            v-for="i in filterPlatformNames(result.gameInfo.platformNames)"
                                            :key="i"
                                        >
                                            <i :class="i"></i>
                                        </div>
                                    </template>
                                    <template v-else-if="resetType(result.type, 'JiaGe')">
                                        <div class="template-icon">
                                            <i :class="handleSinglePlatformName(result.gamePriceInfo.platformName)"></i>
                                        </div>
 
                                        <div class="game-free" v-if="result.gamePriceInfo.beFree && !gameTags">
                                            免费
                                        </div>
                                        <template v-else>
                                            <div class="game-price-box" v-if="!gameTags">
                                                <span class="price">￥{{ result.gamePriceInfo.price }}</span>
                                                <span
                                                    class="priceOriginal"
                                                    v-if="
                                                        result.gamePriceInfo.priceOriginal != result.gamePriceInfo.price
                                                    "
                                                    >￥{{ result.gamePriceInfo.priceOriginal }}</span
                                                >
                                                <span
                                                    class="saleDiscountRate"
                                                    v-if="
                                                        result.gamePriceInfo.saleDiscountRate != 0 &&
                                                            !result.gamePriceInfo.bePriceLowest
                                                    "
                                                    >{{
                                                        `-${Math.floor(result.gamePriceInfo.saleDiscountRate * 100)}%`
                                                    }}</span
                                                >
                                                <span class="saleDiscountRate" v-if="result.gamePriceInfo.bePriceLowest"
                                                    >史低</span
                                                >
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                            <div class="game-evaluate" ref="evaluate">
                                <template v-if="!gameTags">
                                    <!-- 
                                        想玩显示条件：
                                            currentUserContentRelation没有值 或者 （beWantPlay为false 并且 bePlayed为false 并且 contentScore为0）
                                        已想玩显示条件：
                                            currentUserContentRelation有值 并且 beWantPlay为true 并且 bePlayed为false 并且 contentScore为0
                                        已玩过显示条件：
                                            currentUserContentRelation有值 并且 beWantPlay为false 并且 bePlayed为true 并且 contentScore为0
                                        已评分显示条件：
                                            currentUserContentRelation有值 并且 beWantPlay为false 并且 bePlayed为false 并且 contentScore不为0
                                     -->
                                    <i
                                        class="xiangWan"
                                        v-show="
                                            !result.currentUserContentRelation ||
                                                (!result.currentUserContentRelation.beWantPlay &&
                                                    !result.currentUserContentRelation.bePlayed &&
                                                    !result.currentUserContentRelation.contentScore)
                                        "
                                        @click.stop="labelGame(result.id)"
                                    ></i>
                                    <i
                                        class="yiXiangWan"
                                        v-if="
                                            result.currentUserContentRelation &&
                                                result.currentUserContentRelation.beWantPlay &&
                                                !result.currentUserContentRelation.bePlayed &&
                                                !result.currentUserContentRelation.contentScore
                                        "
                                        @click.stop="cancelLabelGame(result.id)"
                                    ></i>
                                    <i
                                        class="wanGuo"
                                        v-if="
                                            result.currentUserContentRelation &&
                                                !result.currentUserContentRelation.beWantPlay &&
                                                result.currentUserContentRelation.bePlayed &&
                                                !result.currentUserContentRelation.contentScore
                                        "
                                    ></i>
                                    <i
                                        class="yiPingFen"
                                        v-if="
                                            result.currentUserContentRelation &&
                                                !result.currentUserContentRelation.beWantPlay &&
                                                !result.currentUserContentRelation.bePlayed &&
                                                result.currentUserContentRelation.contentScore
                                        "
                                    ></i>
                                </template>

                                <p v-else class="game-publishTimeCaption">
                                    {{ result.gameInfo.publishTimeCaption }}<br /><span>上市</span>
                                </p>
                            </div>
                        </div>
                        <!-- 游戏描述 -->
                        <div class="gameDescription" v-if="result.description && result.description.length > 0">
                            <div class="text">
                                {{ result.description }}
                            </div>
                        </div>
                        <!-- 游戏代金券 -->
                        <!-- <div class="gameCashCoupon">
                            <div class="CashCouponItem">
                                <div class="text">
                                    <i></i>
                                    <span>领取代金券</span>
                                </div>
                                <i></i>
                            </div>
                        </div> -->
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
import { labelGame, cancelLabelGame } from "../api/request";
export default {
    name: "gameItem",
    props: {
        result: {
            type: [Object, Number],
            default: 0
        },
        dataIndex: {}
    },
    data() {
        return {
            gameTags: this.$ajax.getQueryString("gameTags")
        };
    },
    mounted() {
        this.$nextTick(() => {
            let detailHeight = this.$refs.detail.clientHeight;
            this.$refs.evaluate.style.height = `${detailHeight}px`;
            // console.log(this.$refs.gameInfes.clientHeight)
        });
    },
    methods: {
        //处理平台数组去重
        // result.gameInfo.platformNames
        filterPlatformNames(platformNames) {
            let psn = ["PSN", "PS4", "PS5"];
            let xbl = ["XBL", "XBONE", "XSX", "XBox360"];
            let phone = ["iOS", "Android"];
            let platformList = [];
            if (platformNames.indexOf("iOS") != -1 && platformNames.indexOf("Android") != -1) {
                let AndIndex = platformNames.indexOf("Android");
                platformNames.splice(AndIndex, 1);
            }
            platformNames.map(item => {
                if (psn.indexOf(item) != -1 && platformList.indexOf("PSN") == -1) {
                    platformList.push("PSN");
                }
                if (xbl.indexOf(item) != -1 && platformList.indexOf("XBL") == -1) {
                    platformList.push("XBL");
                }

                if (psn.indexOf(item) == -1 && xbl.indexOf(item) == -1) {
                    platformList.push(item);
                }
            });
            return platformList;
        },
        // 处理单个平台 比如：育碧
        // result.gamePriceInfo.platformName
        handleSinglePlatformName(platformName) {
            if (platformName == "育碧") {
                return "yubi";
            } else {
                return platformName;
            }
        },
        // 打开游戏库
        RunGameLibrary() {

            if (this.result.type == "youXi_HengBan_PingFen_BiaoQian_PingTai__XiangWan" || this.result.type == "youXi_HengBan_PingFen_BiaoQian_JiaGe__XiangWan") {
                
                let a = document.createElement("a");
                {
                    a.href = this.result.contentUrl;
                    a.target = "_blank";
                }
                a.click();
                a.remove();

                GSAppJsApi.UMeng.recordEvent("i_cannot_use_x5", "");
                this.$utils.Statistics(this.result.gameInfo.id);
            }
        },
        // 关注游戏
        labelGame(GameId) {
            labelGame({
                GameId: GameId
            }).then(response => {
                if (response.error == "") {
                    this.$toast({
                        message: "想玩成功!"
                    });
                    this.result["currentUserContentRelation"]["beWantPlay"] = true;
                } else {
                    this.$toast({
                        message: response.error
                    });
                }
            });
        },
        // 取消关注游戏
        cancelLabelGame(GameId) {
            cancelLabelGame({
                GameId: GameId
            }).then(response => {
                if (response.error == "") {
                    this.$toast({
                        message: "取消想玩成功!"
                    });
                    this.result["currentUserContentRelation"]["beWantPlay"] = false;
                } else {
                    this.$toast({
                        message: "取消想玩失败!"
                    });
                }
            });
        },
        beforeEnter: function(el) {
            el.style.opacity = 0;
        },
        enter: function(el, done) {
            let that = this;
            var delay = this.dataIndex * 130;
            setTimeout(function() {
                that.$Velocity(el, { opacity: 1 }, { complete: done, duration: 500 });
            }, delay);
        },
        leave: function(el, done) {
            let that = this;
            var delay = this.dataIndex * 130;
            setTimeout(function() {
                that.$Velocity(el, { opacity: 0 }, { complete: done, duration: 500 });
            }, delay);
        },
        resetType(typeString, matchString) {
            typeString = typeString.substring(0, typeString.lastIndexOf("_"));
            if (typeString.indexOf(matchString) != -1) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.gameItem {
    position: relative;
    padding: 20px 16px;
    height: auto;
    width: 100%;
    &.biaoTiLan {
        height: auto;
        &::after {
            display: none;
        }
    }
    &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: calc(100% - 32px);
        height: 0.5px;
        @include newsItemAfter_Background($newsItemAfter_Background);
    }
    &:last-of-type {
        &::after {
            display: none;
        }
    }
    .game-biaoTiLan {
        display: flex;
        align-items: center;
        height: 32px;
        width: 100%;
        font-size: 18px;
        color: #222;
        font-weight: bold;
    }
    .loadingBox {
        width: 100%;
        height: 100%;
        background-color: transparent;
        transition: all 0.1s;
        // 鱼骨色块
        &.loding {
            background-color: #dcdfe6;
            border-radius: 4px;
            animation: lodingColor 2s ease-in-out infinite;
        }

        // 动画执行块
        .animationBox {
            display: flex;
            width: 100%;
            height: 100%;
            align-items: flex-start;
            justify-content: space-between;
        }
        .game-cover {
            display: block;
            margin-right: 12px;
            width: 76px;
            height: 108px;
            border-radius: 4px;
            overflow: hidden;
            user-select: none;
        }
        .gameContent {
            flex: 1;
            width: 0;
            height: 100%;
            .gameInfes {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                margin-bottom: 12px;
                &:last-of-type {
                    margin-bottom: 0;
                }
                .game-detail {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    flex: 1;
                    padding-right: 12px;
                    width: 0;
                    height: auto;
                    box-sizing: border-box;
                    .game-name {
                        margin-bottom: 6px;
                        font-size: 15px;
                        @include newsContentColor($newsContentColor);
                        line-height: 20px;
                        font-weight: 500;
                    }
                    .game-score {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        height: 14px;
                        font-size: 10px;
                        @include Color2($Color2);
                        line-height: 1;
                        .score-star {
                            margin-right: 3px;
                            width: 51px;
                            height: 10px;
                            // background: url("../assets/image/Star_Icon.png") repeat-x 0 0 / 10px;
                            background-size: 10px;
                            background-repeat: repeat-x;
                            background-position: 0 0;
                            @include Star_Icon($Star_Icon);
                            div {
                                height: 100%;
                                background: url("../assets/image/StarRed_Icon.png") repeat-x 0 0 / 10px;
                            }
                        }
                        .score-text {
                            margin-top: 2px;
                            margin-right: 10px;
                        }
                    }
                    .game-tag {
                        margin-bottom: 8px;
                        font-size: 12px;
                        color: #999;
                        line-height: 18px;
                    }
                    .game-template {
                        display: flex;
                        align-items: center;
                        height: 16px;
                        .template-icon {
                            padding: 3px 4px;
                            padding-right: 0;
                            width: 10px;
                            height: 10px;
                            @include Background3($Background3);
                            &:first-of-type {
                                border-top-left-radius: 1px;
                                border-bottom-left-radius: 1px;
                            }
                            &:last-of-type {
                                padding-right: 4px;
                                border-top-right-radius: 1px;
                                border-bottom-right-radius: 1px;
                            }
                            i {
                                display: block;
                                width: 10px;
                                height: 10px;
                                background-size: 10px;
                                background-position: center;
                                background-repeat: no-repeat;
                                &.PS4,
                                &.PS5,
                                &.PSN {
                                    @include PSN($PSN);
                                }
                                &.XBONE,
                                &.XSX,
                                &.XBL {
                                    @include XBL($XBL);
                                }
                                &.Steam {
                                    @include Steam($Steam);
                                }
                                &.PC {
                                    @include PC($PC);
                                }
                                &.NS {
                                    @include NS($NS);
                                }
                                &.Mobile {
                                    @include Mobile($Mobile);
                                }
                                &.Android {
                                    @include Mobile($Mobile);
                                }
                                &.iOS {
                                    @include Mobile($Mobile);
                                }
                                &.FengHuang {
                                    @include FengHuang($FengHuang);
                                }
                                &.yubi {
                                    @include YuBi($YuBi);
                                }
                                &.Epic {
                                    @include Epic($Epic);
                                }
                            }
                        }
                        .game-free {
                            display: flex;
                            height: 16px;
                            align-items: center;
                            @include Background3($Background3);
                            padding-left: 8px;
                            padding-right: 4px;
                            font-size: 10px;
                            color: #222222;
                            line-height: 1;
                        }
                        .game-price-box {
                            display: flex;
                            height: 16px;
                            align-items: center;
                            @include Background3($Background3);
                            padding-left: 8px;
                            .price {
                                font-size: 10px;
                                @include newsContentColor($newsContentColor);
                                padding-right: 4px;
                            }
                            .priceOriginal {
                                font-size: 10px;
                                @include newsTimeColor($newsTimeColor);
                                padding-right: 4px;
                                text-decoration: line-through;
                            }
                            .saleDiscountRate {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100%;
                                padding: 0 2px;
                                background: #414449;
                                color: #fff;
                                font-size: 10px;
                                border-top-right-radius: 1px;
                                border-bottom-right-radius: 1px;
                            }
                        }
                    }
                }
                .game-evaluate {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    height: 108px;
                    width: 63px;
                    background-position: left center;
                    background-repeat: no-repeat;
                    background-size: 1px auto;
                    @include GameHr($GameHr);
                    // background: url("../assets/image/GameHr.png") no-repeat left center / 1px auto;
                    i {
                        position: relative;
                        z-index: 3;
                        display: block;
                        width: 50px;
                        height: 50px;
                        cursor: pointer;
                        &.wanGuo {
                            background: url("../assets/image/WanGuo.png") no-repeat center / 50px;
                        }
                        &.xiangWan {
                            background: url("../assets/image/XiangWanOff.png") no-repeat center / 50px;
                        }
                        &.yiXiangWan {
                            background-position: 0 0;
                            background-repeat: no-repeat;
                            background-size: auto 50px;
                            @include yixiangwan($yixiangwan);
                            animation: yiXiangWan 0.3s steps(6, end) forwards;
                        }
                        &.yiPingFen {
                            background: url("../assets/image/Yipingfen.png") no-repeat center / 50px;
                        }
                        @keyframes yiXiangWan {
                            to {
                                background-position-x: 100%;
                            }
                        }
                    }
                    .game-publishTimeCaption {
                        display: block;
                        width: 100%;
                        text-align: center;
                        font-size: 10px;
                        @include newsContentColor($newsContentColor);
                        span {
                            font-size: 8px;
                            @include Color2($Color2);
                        }
                    }
                }
            }
        }
        .gameDescription {
            margin-bottom: 12px;
            &:last-of-type {
                margin-bottom: 0;
            }
            .text {
                display: block;
                padding: 5px 8px;
                @include Background3($Background3);
                border-radius: 6px;
                overflow: hidden;
                font-size: 12px;
                @include Color2($Color2);
                line-height: 17px;
                text-align: justify;
                box-sizing: border-box;
                white-space: pre-line;
            }
        }
        .gameCashCoupon {
            .CashCouponItem {
                display: flex;
                align-items: center;
                padding: 4px 12px;
                height: 28px;
                width: 100%;
                border-radius: 4px;
                overflow: hidden;
                background: #fff0ef;
                box-sizing: border-box;
                .text {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    width: 0;
                    flex: 1;
                    font-size: 14px;
                    color: #eb413d;
                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url("../assets/image/CashCouponIcon1.png") no-repeat center / 16px;
                        margin-right: 8px;
                    }
                }
                i {
                    display: block;
                    width: 12px;
                    height: 12px;
                    background: url("../assets/image/CashCouponIcon2.png") no-repeat center / 12px;
                }
            }
        }
    }
}
</style>
